import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs'


export class DataContextService<T> {
  constructor(private http: HttpClient,private baseUrl: string) {}
 

  //Get
  get(url: string): Observable<T> {
    return this.http.get<T>(url);
  }
 
  // Read
  getAll(): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl);
  }
 
  getById(id: number): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${id}`);
  }

  // post
  post(item: T): Observable<T> {
    return this.http.post<T>(this.baseUrl, item);
  }
 
  // Update
  update(id: number, item: T): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${id}`, item);
  }
 
  // Delete
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
